/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import type { SVGProps } from 'react';

export type IllustrationSizeVariants =
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxlarge'
  | 'xxxlarge'
  | 'xxxxlarge';
export type IllustrationProps = {
  width?: number | string;
  height?: number | string;
  size?: IllustrationSizeVariants;
};
const IllustrationSpotBell = ({
  size = 'medium',
  width,
  height,
  ...props
}: IllustrationProps) => {
  let presetWidth: string | undefined;
  let presetHeight: string | undefined;
  const presets = {
    small: '48px',
    medium: '68px',
    large: '92px',
    xlarge: '122px',
    xxlarge: '156px',
    xxxlarge: '194px',
    xxxxlarge: '236px',
  };
  if (size) {
    presetWidth = presets[size];
    presetHeight = presets[size];
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 68 68"
      data-xds="IllustrationSpotBell"
      height={height || presetHeight}
      role="presentation"
      width={width || presetWidth}
      {...props}
    >
      <path
        fill="var(--xdlColorIllustrationBackground)"
        d="M64.99 52.94c-.23-6.2-.84-11.13-6.34-13.45-1.53-.65-3.35-2-3.77-6.8-1.39-15.95-7.7-20.29-11.89-23.17-1.53-1.05-2.63-1.81-3.07-2.8a5.74 5.74 0 0 0-5.25-3.4h-1.43a5.74 5.74 0 0 0-5.25 3.4c-.44.99-1.54 1.75-3.08 2.8-.69.48-1.44.99-2.22 1.6V1.9h-5v7.85L12.34 4.4 8.8 7.94l5.35 5.35H6.3v5h10.4c-1.73 3.33-3.11 7.9-3.68 14.4-.42 4.8-2.23 6.15-3.77 6.8-5.5 2.32-6.12 7.25-6.34 13.45l-.09 2.59h20.57c1.46 4.91 6.04 8.44 11.29 8.44s9.82-3.52 11.29-8.44h19.11z"
      />
      <path
        fill="#fff"
        d="M62.5 53.03c-.23-6.34-.9-9.59-4.81-11.24-3.66-1.54-4.94-4.93-5.29-8.88-1.85-21.19-12.35-19.77-14.75-25.17a3.25 3.25 0 0 0-2.97-1.92h-1.42c-1.28 0-2.45.75-2.97 1.92-2.4 5.41-12.91 3.98-14.75 25.17-.34 3.95-1.63 7.35-5.29 8.88-3.91 1.65-4.58 4.9-4.81 11.24h57.07z"
      />
      <path
        fill="#27DBA8"
        d="M25.45 53.03c.43 4.73 4.4 8.44 9.24 8.44s8.81-3.71 9.24-8.44z"
      />
      <path
        fill="var(--xdlColorIllustrationOutlinePrimary)"
        d="M50.26 41.02H19.12v1h31.14zM12.347 7.216l-.707.707 6.357 6.357.707-.707zM16.27 15.28H8.31v1h7.96zM20.7 3.9h-1v7.96h1z"
      />
      <path
        fill="var(--xdlColorIllustrationOutlinePrimary)"
        d="m63.01 53.53-.02-.52c-.24-6.69-1.04-9.96-5.12-11.68-3.01-1.26-4.59-3.96-4.98-8.47-1.31-15.01-6.92-18.87-11.02-21.69-1.73-1.19-3.1-2.13-3.77-3.64a3.75 3.75 0 0 0-3.43-2.21h-1.43c-1.48 0-2.83.87-3.43 2.21-.67 1.51-2.04 2.45-3.77 3.64-4.1 2.82-9.72 6.68-11.02 21.69-.39 4.51-1.98 7.2-4.98 8.47-4.08 1.72-4.87 4.99-5.12 11.68l-.02.52h20.11c.66 4.76 4.74 8.44 9.67 8.44s9.01-3.68 9.67-8.44zM10.43 42.25c3.34-1.41 5.17-4.45 5.59-9.3C17.29 18.41 22.68 14.7 26.61 12c1.79-1.23 3.33-2.29 4.12-4.06a2.75 2.75 0 0 1 2.51-1.62h1.43c1.09 0 2.07.64 2.51 1.62.78 1.77 2.33 2.83 4.12 4.06 3.94 2.71 9.33 6.42 10.59 20.95.42 4.85 2.25 7.9 5.59 9.3 3.5 1.47 4.23 4.26 4.49 10.28H5.94c.25-6.01.99-8.8 4.49-10.28m24.26 18.71c-4.38 0-8.02-3.23-8.67-7.44h17.34c-.65 4.2-4.28 7.44-8.67 7.44"
      />
    </svg>
  );
};
export default IllustrationSpotBell;
